import Mixin from "../mixin.js";
import FormInputs from "../services/inputs-service.js";
import Utils from "../services/utils-service.js";
import Funnel from "../services/funnel-service.js";
import tooltip from "./utils/tooltip.js"

const template = `
    <div class=" summary-card-container" v-if="fs.display(input)"> 
        <ul class="grid summary-type-1" v-if="!input.summary_type || input.summary_type == 1 || input.summary_type == 'waiting_periods'">
            <li v-for="item in input.options" :class="item.class" v-show="fs.display(item)">
            <b-tooltip :element='item' v-if="item.helpText"/> 
                 <span class="title primary-color-text" v-html="parseHtml(item.title)"></span>
                <span v-html="parseHtml(item.value)"></span>
            </li>
        </ul>
        <div class="grid summary-type-2" v-if="input.summary_type == 2 || input.summary_type == 'plan_summary'" >
            <div class="s12 m6 clm" v-for="item in input.quotes">
                <h4 class="text-center primary-color-text">{{item.title}}</h4>
                <ul class="table coverage-table">
                    <li  :id="table_item.field" v-for="(table_item, index) in item.items" :class="table_item.class" class="tr">
                        <span class="td text-right"> {{ table_item.label }}</span>
                        <span class="td text-left"> {{ table_item.value }}</span>
                    </li>
                </ul>
            </div>
            <div class="s12 clm" v-for="(sum_item , index) in input.summary" :id="sum_item.field">
                <span v-if="sum_item.field == 'total_transaction_fee'" class="text-center" >
                    <b-tooltip :element='sum_item' v-if="sum_item.helpText"/> 
                    {{sum_item.label}} {{sum_item.value}}
                </span>
                <h2 class="text-center" v-if="sum_item.field == 'total_monthly_amount'" >
                    {{sum_item.label}} {{sum_item.value}} 
                </h2>
            </div>
        </div> 
    </div>
`;

export default {
    name: 'b-summary',
    template,
    props: ['iuid'],
    mixins: [Mixin],
    components: {
        'b-tooltip': tooltip
    },
    data() {
        return {
        }
    },
    watch: { 
    },
    mounted: function () {
        console.log(this.input);
    },
    computed: {
        fs: function () {
            return new Funnel({ ctx: this.$store, router: this.$router });
        },
        validationRules() {
            return this.input.validation
        },
        input: function () {
            return this.$store.getters.funnel.elements[this.iuid];
        }
    },
    methods: { 
       
    }
};
  